<template>
    <div>
        <div class="header-envelope-icon-orange" @click="onSortRequested()"></div>
        <span v-if="ascSort" class="ag-icon ag-icon-asc"></span>
        <span v-if="descSort" class="ag-icon ag-icon-desc"></span>
    </div>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
    name: 'TableHeaderMessages',
    data() {
        return {
            order: null
        };
    },
    mounted() {
        this.params.column.addEventListener('sortChanged', this.onSortChanged);
        this.onSortChanged();
    },
    computed: {
        ascSort() {
            return this.order === 'asc';
        },
        descSort() {
            return this.order === 'desc';
        }
    },
    methods: {
        onSortChanged() {
            this.order = this.params.column.getSort();
        },
        onSortRequested() {
            if (this.order) {
                this.order = this.order === 'asc' ? 'desc' : '';
            } else {
                this.order = 'asc';
            }
            this.params.setSort(this.order, false);
        }
    }
});
</script>
